/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendResourceResponse {
    getFixupPrototypeFunction() { return InfraResourceTrendResourceResponse.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendResourceResponse>): InfraResourceTrendResourceResponse {
        let obj = Object.assign(new InfraResourceTrendResourceResponse(), model);
        InfraResourceTrendResourceResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendResourceResponse>): InfraResourceTrendResourceResponse {
        if (!model) return null;
        return InfraResourceTrendResourceResponse.newInstance(<InfraResourceTrendResourceResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendResourceResponse) {
        if (!obj) return;

        models.InfraResourceTrendResourceResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendResourceResponse): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendResourceResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.InfraResourceTrendResource.fixupPrototype(val);
            }
        }
    }

    /**
     * List of resources matching the trend criteria.
     */
    resources: Array<models.InfraResourceTrendResource>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
